import dayjs from 'dayjs';

export default {
    'searchList': {
        'searchTxt': [
            {
                'name': '结算申请单号',
                'value': 'apApplyNo',
                'type': 'input',
                'unfold': true,
                'span': 3,
                'multiple': false
            },
            {
                'name': '系统发票号',
                'value': 'sysInvoiceNo',
                'type': 'input',
                'unfold': true,
                'span': 3,
                'multiple': false
            },
            {
                'name': '发票号码',
                'value': 'invoiceNo',
                'type': 'input',
                'unfold': true,
                'span': 3,
                'multiple': false
            },
            {
                'name': '发票标签',
                'value': 'invoiceLabel',
                'type': 'select',
                'unfold': true,
                'optionNum': 'BMS_AP_INVOICE_LABEL',
                'span': 3,
                'multiple': false
            },
            {
                'name': '发票状态',
                'value': 'makeInvoiceStatuses',
                'type': 'select',
                'unfold': true,
                'span': 3,
                'optionNum': 'BMS_AP_OPEN_INVOICE_STATUS',
                'multiple': true
            },
            {
                'name': '发票类型',
                'value': 'invoiceType',
                'type': 'select',
                'optionNum': 'SYS_SC_INVOICE_TYPE_BMS',
                'unfold': true,
                'span': 3,
                'multiple': false
            },
            {
                'name': '原结算申请单号',
                'value': 'oldApplyNo',
                'type': 'input',
                'unfold': true,
                'span': 3,
                'multiple': false
            },
            {
                'name': '发票红冲申请单号',
                'value': 'rushApplyNo',
                'type': 'input',
                'unfold': true,
                'span': 3,
                'multiple': false
            },
            {
                'name': '原蓝票号',
                'value': 'oldInvoiceNo',
                'type': 'input',
                'unfold': true,
                'span': 3,
                'multiple': false
            },
            {
                'name': '创建时间',
                'value': 'searchTime',
                'startTime': 'createTimeFrom',
                'endTime': 'createTimeTo',
                'type': 'time',
                'timeNum': false,
                'data': [
                    dayjs().startOf('month').startOf('day').toDate(),
                    dayjs().endOf('month').endOf('day').toDate()
                ],
                'unfold': true,
                'span': 5
            }
        ],
        'unfoldState': false,
        'advancedBtn': false
    },
    'table':
    {
        'switchType': true,
        'tableCut': false,
        'clickState': true,
        'selectBtn': false,
        'height': 'calc(100vh - 204px)',
        'columns': [
            {
                'label': '结算申请单号',
                'prop': 'apApplyNo',
                'width': '160px'
            },
            {
                'label': '系统发票号',
                'prop': 'sysInvoiceNo',
                'width': '160px'
            },
            {
                'label': '发票标签',
                'prop': 'invoiceLabel',
                'type': 'select',
                'optionNum': 'BMS_AP_INVOICE_LABEL',
                'width': '150px'
            },
            {
                'label': '开票状态',
                'prop': 'makeInvoiceStatus',
                'type': 'select',
                'optionNum': 'BMS_AP_OPEN_INVOICE_STATUS',
                'width': '80px'
            },

            {
                'label': '发票号码',
                'prop': 'invoiceNo',
                'width': '180px'
            },
            {
                'label': '发票类型',
                'prop': 'invoiceType',
                'type': 'select',
                'optionNum': 'SYS_SC_INVOICE_TYPE_BMS',
                'width': '180px'
            },
            {
                'label': '含税金额',
                'prop': 'amt',
                'width': '100px'
            },
            {
                'label': '税率',
                'prop': 'taxRate',
                'width': '80px'
            },
            {
                'label': '税额',
                'prop': 'taxAmt',
                'width': '80px'
            },
            {
                'label': '不含税金额',
                'prop': 'fee',
                'width': '100px'
            },
            {
                'label': '开票日期',
                'prop': 'makeInvoiceDate',
                'width': '150px'
            },
            {
                'label': '原蓝票号',
                'prop': 'oldInvoiceNo',
                'width': '180px'
            },
            {
                'label': '原结算申请单号',
                'prop': 'oldApplyNo',
                'width': '150px'
            },
            {
                'label': '发票红冲申请单号',
                'prop': 'rushApplyNo',
                'width': '150px'
            },
            {
                'label': '创建时间',
                'prop': 'createTime',
                'width': '150px'
            },
            {
                'label': '修改时间',
                'prop': 'modifyTime',
                'width': '150px'
            }],
        'action': [],
        'leftOperation': false,
        'leftWidth': 250
    },
    'page': {
        'layout': 'total, sizes, prev, pager, next, jumper',
        'pageSize': 10
    }
};
